import { useMutation } from '@tanstack/react-query';
import { requestDac8AuditReport } from '@/services/api/dac8-audit';

export const useRequestDac8AuditReport = () => useMutation({ mutationFn: requestDac8AuditReport });
